var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGengduo = function SvgGengduo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.765.432.77 5.985C.284 6.372 0 6.965 0 7.59v8.373C0 17.085.895 18 2.005 18h13.99c1.11 0 2.005-.915 2.005-2.037V7.59c0-.626-.284-1.218-.77-1.605L10.235.432a1.98 1.98 0 0 0-2.47 0Zm1.716.95 6.995 5.553a.836.836 0 0 1 .312.655v8.373c0 .458-.358.825-.793.825H2.005c-.435 0-.793-.367-.793-.825V7.59c0-.257.116-.5.312-.655L8.52 1.382a.768.768 0 0 1 .962 0Z",
    fill: "#333",
    fillRule: "nonzero"
  })));
};

export default SvgGengduo;